<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn class="success" v-on="on">
        <v-icon left>person_add</v-icon>
        Add Member
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-icon left>person_add</v-icon>
        <span class="headline">Add New Member</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon large color="error">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container grid-list-md class="py-0">
        <v-card-text class="py-0">
          <v-form ref="add_member_form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="phone"
              label="Phone *"
              :rules="[(v) => !!v || 'Phone is required']"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            :loading="loading"
            :disabled="loading || !valid"
            @click="save"
          >
            Add
          </v-btn>
        </v-card-actions>
        <div v-if="error" class="pb-4">
          <div
            v-if="responseList.Exist_Dasher && responseList.Exist_Dasher.length"
          >
            <h2 style="color: #f44">Already Exists:</h2>
            <span
              class="mr-1"
              v-for="(dasher, i) in responseList.Exist_Dasher"
              :key="i"
            >
              {{ dasher }},
            </span>
          </div>

          <div
            v-if="
              responseList.Failed_Dasher && responseList.Failed_Dasher.length
            "
          >
            <br />
            <h2 style="color: #f44">Failed:</h2>
            <span
              class="mr-1"
              v-for="(dasher, i) in responseList.Failed_Dasher"
              :key="i"
            >
              {{ dasher }},
            </span>
          </div>

          <div
            v-if="
              responseList.Invalid_Dasher && responseList.Invalid_Dasher.length
            "
          >
            <br />
            <h2 style="color: #f44">Invalid:</h2>
            <span
              class="mr-1"
              v-for="(dasher, i) in responseList.Invalid_Dasher"
              :key="i"
            >
              {{ dasher }},
            </span>
          </div>

          <div
            v-if="responseList.SuccessArray && responseList.SuccessArray.length"
          >
            <br />
            <h2 style="color: #4d4">Success:</h2>
            <span
              class="mr-1"
              v-for="(dasher, i) in responseList.SuccessArray"
              :key="i"
            >
              {{ dasher }},
            </span>
          </div>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  export default {
    props: ["code"],
    data() {
      return {
        dialog: false,
        loading: false,
        valid: false,
        phone: "",
        error: false,
        responseList: null,
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      close() {
        this.dialog = false;
        this.phone = "";
      },
      async save() {
        await this.$refs.add_member_form.validate();
        if (this.valid) {
          try {
            this.loading = true;
            this.error = false;
            const { data } = await api.storeData(
              this.auth.token,
              "agent.group-members",
              { agent_group_code: this.code, user_mobile: this.phone }
            );

            if (data.error) {
              this.$emit("result", ["Member creation Unsuccessful", "error"]);
              this.error = true;
              this.responseList = data.data;
            } else {
              this.$emit("result", ["Member created successfully", "success"]);
              this.close();
            }

            this.loading = false;
          } catch (error) {
            this.loading = false;
          }
        }
      },
    },
  };
</script>
